export default __webpack_public_path__ + "static/media/ars-maquette-light-webfont.5d8ea786.ttf";